export const PROJECT_IMAGE_MAX_UPLOAD_BYTES = 10 * 1024 * 1024;

const MAX_MB = PROJECT_IMAGE_MAX_UPLOAD_BYTES / (1024 * 1024);

export function projectImageOversizeMessage(fileName: string): string {
  return `"${fileName}" exceeds the ${MAX_MB} MB limit. Please choose a smaller image.`;
}
